import { useState, useEffect } from 'react';
import MobileMenuSection from './MobileMenuSection.tsx';
import { MobileMenuProps } from '@/types';

const MobileMenu = ({
                      adminItems,
                      contentItems,
                      reportItems = [],
                      adsItems = [],
                      settingsItems,
                      userItems
                    }: MobileMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const closeMenu = () => {
    setIsVisible(false);
    // Wait for animation to complete before hiding
    setTimeout(() => setIsOpen(false), 300);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      // Trigger animation after state update
      setTimeout(() => setIsVisible(true), 10);
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <>
      <button
        onClick={() => isOpen ? closeMenu() : setIsOpen(true)}
        className="text-white p-2 rounded-lg hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/20"
        aria-label="Open menu"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </button>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div
            className={`fixed inset-0 bg-black/50 transition-opacity duration-300 ${
              isVisible ? 'opacity-100' : 'opacity-0'
            }`}
            onClick={closeMenu}
          />
          <div
            className={`fixed top-0 right-0 h-full w-80 bg-white dark:bg-gray-900 shadow-xl flex flex-col transition-transform duration-300 ease-out ${
              isVisible ? 'translate-x-0' : 'translate-x-full'
            }`}
          >
            <div className="p-4 border-b border-gray-200 dark:border-gray-700">
              <div className="flex justify-between items-center">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Menú</h2>
                <button
                  onClick={closeMenu}
                  className="p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800"
                >
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </div>
            </div>

            <div className="p-4 space-y-6 overflow-y-auto flex-1">
              <MobileMenuSection
                closeMenu={closeMenu}
                title="Administración"
                items={adminItems}/>
              <MobileMenuSection
                closeMenu={closeMenu}
                title="Contenido"
                items={contentItems}/>
              {reportItems.length > 0 && (
                <MobileMenuSection
                  closeMenu={closeMenu}
                  title="Reportes"
                  items={reportItems}/>
              )}
              {adsItems.length > 0 && (
                <MobileMenuSection
                  closeMenu={closeMenu}
                  title="Publicidad"
                  items={adsItems}/>
              )}
              <MobileMenuSection
                closeMenu={closeMenu}
                title="Configuración"
                items={settingsItems}/>
              <MobileMenuSection
                title="Usuario"
                closeMenu={closeMenu}
                items={userItems}/>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileMenu;
